module.exports = __webpack_public_path__ + "img/pro_four.74897476.jpg";